import { useEffect } from 'react';
import { useWalletKit } from '@mysten/wallet-kit';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '/api';

export function useAutoLogin(setUser: any, setUserSessionToken: any) {
  const { currentAccount, isConnected } = useWalletKit();

  useEffect(() => {
    const autoLogin = async () => {
      // Only auto-login if wallet is connected and we don't have a session
      const existingToken = localStorage.getItem('userSessionToken');
      if (!isConnected || !currentAccount || existingToken) {
        return;
      }

      console.log('🔄 Auto-login: Wallet connected, creating session...');

      try {
        const response = await fetch(`${BACKEND_URL}/auth/user/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            walletAddress: currentAccount.address,
            profileData: {
              username: '',
              avatar: '',
              bio: ''
            }
          }),
        });

        if (!response.ok) {
          console.error('Auto-login failed:', response.status);
          return;
        }

        const result = await response.json();
        
        if (result.success) {
          console.log('✅ Auto-login successful!');
          
          // Update state
          setUser(result.user);
          setUserSessionToken(result.sessionToken);
          
          // Save to localStorage
          localStorage.setItem('userSessionToken', result.sessionToken);
          localStorage.setItem('userData', JSON.stringify(result.user));
          
          console.log('Session created:', result.sessionToken.substring(0, 20) + '...');
        }
      } catch (error) {
        console.error('Auto-login error:', error);
      }
    };

    // Run auto-login
    autoLogin();
  }, [isConnected, currentAccount, setUser, setUserSessionToken]);
}

export default useAutoLogin;
